import { render, staticRenderFns } from "./AdminBrand.vue?vue&type=template&id=467cadb4&scoped=true"
import script from "./AdminBrand.vue?vue&type=script&lang=js"
export * from "./AdminBrand.vue?vue&type=script&lang=js"
import style0 from "./AdminBrand.vue?vue&type=style&index=0&id=467cadb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467cadb4",
  null
  
)

export default component.exports